import React, { useEffect, useState } from 'react';
import cn from 'classnames';

const ReviewOverview = ({ total_reviews, ratings_breakdown = {} }: any) => {
   const [ratingsArr, setRatingsArr] = useState<number[]>();

   const ratingPercentage = (rating: number) => {
      if (!rating) return 0.1;
      if (ratingsArr?.length) {
         const maxRating = Math.max(...ratingsArr);
         const percentage = maxRating === rating ? 100 : (rating / maxRating) * 100;
         console.log(maxRating, rating, percentage);
         return percentage;
      } else return 0.1;
   };

   const colors = ['#51C041', '#057D8B', '#3DC2C2', '#FF8300', '#B91036'];

   useEffect(() => {
      if (Object.keys(ratings_breakdown).length) {
         const _ratings: number[] = Object.values(ratings_breakdown);
         setRatingsArr(_ratings);
      }
   }, [ratings_breakdown]);

   return (
      <div className={cn('flex flex-col gap-0.5 text-xs', total_reviews && 'w-52')}>
         {total_reviews && Object.keys(ratings_breakdown)?.length
            ? ['5', '4', '3', '2', '1'].map((_key: string, index: number) => (
                 <div className="flex items-center gap-2" key={_key}>
                    <span>{_key}</span>
                    <span
                       className={cn(`h-1.5 bg-grey-200 rounded-lg`)}
                       style={{
                          backgroundColor:
                             ratings_breakdown?.[_key] > 0 ? colors[index] : '#666666',
                          width: `${ratingPercentage(ratings_breakdown?.[_key] || 0)}%`,
                       }}></span>
                    <span>{ratings_breakdown?.[_key] || 0}</span>
                 </div>
              ))
            : ['5', '4', '3', '2', '1'].map(_key => (
                 <div className="flex items-center gap-2" key={_key}>
                    <span>{_key}</span>
                    <span className="w-6 h-1.5 bg-grey-200 rounded-lg"></span>
                    <span>0</span>
                 </div>
              ))}
      </div>
   );
};

export default ReviewOverview;
